import { url } from '@tencent/ppd-base-libs';

/**
 * 获取投放渠道券ID
 * 同时实现url的变化，用户无法通过分享当前这个url来让另外一个用户领取该券
 * @param key url中用来确定当前渠道的key，当url中存在该key时，才会执行对应逻辑
 * @returns
 */
export function ensureChannelCouponId(key: string): string | void {
  /**
   * 当url中存在channelCouponId时，把值记录到sessionStorage中，并跳转到另外一个url，
   * 这样，当用户分享当前url时，另外一个用户拿到当前url，并不能得到具体的channelCouponId，
   * 也就无法进入对应券的领券界面
   */
  const channelCouponId = url.getUrlParam(key);
  if (channelCouponId) {
    // 实现一个随机字符串作为key，避免用户模拟sessionStorage，自己手动写一个key
    const newKey = createRandomKey();
    sessionStorage.setItem(newKey, channelCouponId);

    // 做一个延时，一是避免有些组件在当前组件之后渲染还会利用到url，另一方面在另外的组件中也可能处理url避免进行了两次处理
    setTimeout(() => {
      // 生成新url，替换为channelCouponIdKey
      const newUrl = window.location.href.replace(`${key}=${channelCouponId}`, `${key}Key=${newKey}`);
      window.history.replaceState(null, '', newUrl);
    }, 100);

    return channelCouponId;
  }

  /**
   * url中存在channelCouponIdKey，那么基于该key到sessionStorage中取，
   * 这样就可以做到，用户刷新当前url的时候（由于url中带有channelCouponIdKey），可以再次进入渠道券领取界面
   */
  const channelCouponIdKey = url.getUrlParam(`${key}Key`);
  if (channelCouponIdKey) {
    const cachedChannelCouponId = sessionStorage.getItem(channelCouponIdKey);
    if (cachedChannelCouponId) {
      return cachedChannelCouponId;
    }
  }
}

function createRandomKey() {
  const chars = 'ABCDEFJKIJKLMNOPQRSTUVWXYZ';
  const max = chars.length;
  let randomStr = '';
  for (let i = 0; i < 16; i ++) {
    randomStr += chars.charAt(Math.floor(Math.random() * max));
  }
  return randomStr;
}
